<template>
  <div class="mt-8">
    <px-view-module-header module-name="Marketplace" :breadcrumbs="breadcrumbs"/>

    <v-card class="rounded-card card-shadow mt-8">
      <v-card-text class="text--primary">
        <px-view-header-title title="Minhas vendas"/>
        <px-compras-header @change="onRefresh"/>
        <div>
          <v-skeleton-loader type="list-item-two-line@10" :loading="loading">
            <div v-if="!loading && !compras.content.length" align="center"
                 class="font-weight-bold mb-5 mt-10">
              <h2>Nenhuma venda encontrada</h2>
            </div>
            <v-expansion-panels class="mb-6" multiple>
              <v-expansion-panel
                class="mt-3 rounded-card no-divider card-shadow"
                v-for="(compra) in compras.content"
                :key="compra.id"
              >
                <v-expansion-panel-header disable-icon-rotate>
                  <template v-slot:actions>
                    <v-btn icon @click.stop link :to="`/marketplace/vendas/${compra.id}`">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <px-situacao-compra-marketplace-icon is-fornecedor
                                                         :situacao="compra.situacao"/>
                  </template>
                  <px-compras-item-header :compra="compra"/>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <px-compras-item-content :compra="compra" @change="onRefresh"/>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-skeleton-loader>
        </div>
        <v-pagination
          v-model="page"
          :length="pagesLimit"
          :total-visible="5"
        ></v-pagination>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import ComprasHeader from './ComprasHeader.vue';
import ComprasItemHeader from './ComprasItemHeader.vue';
import ComprasItemContent from './ComprasItemContent.vue';
import CompraService from './compras-service';

const LIMIT = 15;
const PAGE = 1;

export default {
  mixins: [paginationMixin],
  data() {
    return {
      page: PAGE,
      pagesLimit: 1,
      loading: false,
      compras: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: PAGE,
        limit: LIMIT,
        offset: 0,
        filter: '',
        sort: 'dataCompra',
        sortDesc: true,
      },
      optionsList: {
        page: PAGE,
        itemsPerPage: LIMIT,
        sortBy: '',
        sortDesc: false,
        multiSort: false,
      },
      breadcrumbs: [
        { text: 'Marketplace' },
        { text: 'Minhas vendas' },
      ],
    };
  },
  computed: {
    ...mapGetters('listagemCompras', ['stringFilter']),
  },
  methods: {
    onChangeOptions() {
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCompras();
    },
    setPagesLimit() {
      this.pagesLimit = Math.ceil(this.compras.total / LIMIT);
    },
    onRefresh() {
      this.getCompras();
    },
    getCompras() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      CompraService.getCompras({
        query: this.stringFilter,
        limit,
        offset,
      })
        .then(({ data }) => {
          this.compras = data;
          this.setPagesLimit();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    page(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.optionsList.page = newValue;
      this.onChangeOptions();
    },
  },
  created() {
    this.getCompras();
  },
  components: {
    pxComprasItemHeader: ComprasItemHeader,
    pxComprasItemContent: ComprasItemContent,
    pxComprasHeader: ComprasHeader,
  },
};
</script>
